import i18n from "../i18n/i18n";
import {RelationType} from "../transportation/models/relation";

export default class RelationTypeDropdownItems {
    public static getRelationTypes () {
        return [
            {
                id: RelationType.TICKET_EXPORT,
                name: i18n.t("relationType.TICKET_EXPORT")
            },
            {
                id: RelationType.ROAD_DEPO_FERRY,
                name: i18n.t("relationType.ROAD_DEPO_FERRY")
            },
            {
                id: RelationType.FERRY_DEPO_ROAD,
                name: i18n.t("relationType.FERRY_DEPO_ROAD")
            },
            {
                id: RelationType.RAIL_DEPO_FERRY,
                name: i18n.t("relationType.RAIL_DEPO_FERRY")
            },
            {
                id: RelationType.FERRY_DEPO_RAIL,
                name: i18n.t("relationType.FERRY_DEPO_RAIL")
            },
            {
                id: RelationType.RAIL_FERRY,
                name: i18n.t("relationType.RAIL_FERRY")
            },
            {
                id: RelationType.FERRY_RAIL,
                name: i18n.t("relationType.FERRY_RAIL")
            },
            {
                id: RelationType.ROAD_DEPO_ROAD,
                name: i18n.t("relationType.ROAD_DEPO_ROAD")
            },
            {
                id: RelationType.ROAD_DEPO_RAIL,
                name: i18n.t("relationType.ROAD_DEPO_RAIL")
            },
            {
                id: RelationType.RAIL_DEPO_ROAD,
                name: i18n.t("relationType.RAIL_DEPO_ROAD")
            },
            {
                id: RelationType.RAIL_DEPO_RAIL,
                name: i18n.t("relationType.RAIL_DEPO_RAIL")
            },
            {
                id: RelationType.FERRY_DEPO,
                name: i18n.t("relationType.FERRY_DEPO")
            },
            {
                id: RelationType.RAIL_DEPO,
                name: i18n.t("relationType.RAIL_DEPO")
            },
            {
                id: RelationType.ROAD_DEPO,
                name: i18n.t("relationType.ROAD_DEPO")
            }
        ];
    }

    public static getRelationTypesWithoutTicket (){
        return RelationTypeDropdownItems.getRelationTypes().filter(x => x.id !== RelationType.TICKET_EXPORT);
    }

    public static getRelationTypesWithDefault (){
        return RelationTypeDropdownItems.getRelationTypes().concat({
            id: RelationType.DEFAULT,
            name: i18n.t("relationType.DEFAULT")
        });
    }
}